import { FunctionComponent, memo } from "react";
import { useDispatch } from "react-redux";
import { Url } from "@edgetier/types";
import urljoin from "url-join";
import { DetailsFieldTitle, DetailsFieldValue } from "@edgetier/client-components";

import useSimpleQuery from "queries/use-simple-query";
import { ISetup } from "components/settings/setups/setups.types";
import { toastOperations } from "redux/modules/toast";

import BrandDetailsField from "../brand-details-field";

import { IProps } from "./chat-brand-widget-fields.types";

import "./chat-brand-widget-fields.scss";

/**
 * Display brand and widget fields
 * @param setupId
 */
const ChatBrandWidgetFields: FunctionComponent<IProps> = ({ setupId }) => {
    const dispatch = useDispatch();

    const { data, isLoading } = useSimpleQuery<ISetup>(urljoin(Url.Setups, String(setupId)), {
        onError: (serverError) => dispatch(toastOperations.showServerErrorToast("Setup Request Failed", serverError)),
        staleTime: 1000 * 60 * 5,
    });

    return (
        <>
            <tr>
                <td>
                    <DetailsFieldTitle>Widget</DetailsFieldTitle>
                </td>
                <td>
                    <DetailsFieldValue copyText={data?.setup} isLoading={isLoading}>
                        {data?.setup}
                    </DetailsFieldValue>
                </td>
            </tr>
            <BrandDetailsField brandId={data?.brandId} isLoading={isLoading} />
        </>
    );
};

export default memo(ChatBrandWidgetFields);
